import { IoClose } from "react-icons/io5";
import { IoMdCheckmark } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Modal from "../../Submissions/components/Modal";
import { useState } from "react";
import { ActionButton } from "../../../components/Forms/ActionButton";
import { useDeleteBlog, useUpdateBlogStatus } from "../../../queries/blog";
import Chip from "../../../components/Chip";
import { FaEye, FaTrash } from "react-icons/fa";
const ViewIcon = require("../../../utils/media/icons/edit_icon.png");

const BlogListTable = ({ data, toast, onViewImpact }) => {

    const navigate = useNavigate();
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [isRejectionModelOpen, setIsRejectionModelOpen] = useState(false);
    const [deleteModel, setDeleteModel] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const [rejectionReason, setRejectionReason] = useState("");

    const { mutateAsync } = useUpdateBlogStatus();
    const { mutateAsync: deleteBlog } = useDeleteBlog();

    const handleReject = async (id) => {
        mutateAsync({
            status: 'reject',
            blogId: id,
            rejectReason: rejectionReason,
        }, {
            onSuccess: () => {
                toast.success("Blog Rejected");
            },
            onError: () => {
                toast.error("Error rejecting blog");
            }
        });
        setIsModelOpen(false);
    }

    const handleApprove = async (id) => {
        mutateAsync({
            status: 'approve',
            blogId: id,
            rejectReason: '',
        }, {
            onSuccess: () => {
                toast.success("Blog Approved");
            },
            onError: () => {
                toast.error("Error approving blog");
            }
        });
        setIsModelOpen(false);
    }

    const handleDelete = async (id) => {
        const confirm = window.confirm("Are you sure you want to delete this blog?");
        if (!confirm) return;
        deleteBlog(id, {
            onSuccess: () => {
                toast.success("Blog Deleted");
            }
        });
    }

    const renderChipStatus = (status) => {
        if (status === 'active') return <Chip value={status} variant={'filled'} color="green" />;
        if (status === 'rejected') return <Chip value={status} variant={'filled'} color="red" />;
        if (status === 'inactive') return <Chip value={status} variant={'filled'} color="red" />;
        if (status === 'auto approved') return <Chip value={status} variant={'filled'} color="purple" />;
        return <Chip value={status} variant={'filled'} color="blue" />;
    };
    
    const renderChips = (active) => {
        if (active === true) {
            return <Chip value={'Active'} color="green" />
        } else if (active === false) {
            return <Chip value={'Inactive'} color="inactive" />
        } else {
            return <Chip value={active} color="blue" />
        }
    }

    const renderBlogCreator = (item) => {
        if(item?.createdByUser){
            return (
                <span className="capitalize">{item?.createdByUser?.username || "Unknown User"}</span>
            );
        }
        else if(item?.blogType === "System Generated"){
            return (
                <span className="capitalize">Admin</span>
            );
        }
        else if(item?.createdByNgo){
            return (
                <span className="capitalize">{item?.createdByNgo?.ngoName || "Unknown NGO"}</span>
            );
        }
        else if(item?.createdByCompany){
            return (
                <span className="capitalize">{item?.createdByCompany?.companyName || "Unknown Company"}</span>
            );
        }
    }
    
    if (!data || data.length === 0) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-base text-gray-400">No Blogs Found</h1>
            </div>
        );
    }
    return (
        <div className="overflow-x-auto mt-6">
            <table className="w-full border-collapse overflow-visible" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-center">Srl. No.</th>
                        <th className="p-3 text-left">Title</th>
                        <th className="p-3 text-left">Category</th>
                        <th className="p-3 text-left">Blog Type</th>
                        <th className="p-3 text-left">Blog Creator</th>
                        <th className="p-3 text-center">Status</th>
                        <th className="p-3 text-center">Start Date</th>
                        <th className="p-3 text-center">End Date</th>
                        <th className="p-3 text-center">Actions</th>
                    </tr>
                </thead>
                {/* Rejection Model */}
                <Modal isOpen={isRejectionModelOpen} setIsOpen={setIsRejectionModelOpen} onClose={() => setIsRejectionModelOpen(false)}>
                    <div>
                        <h1 className="text-base font-semibold">Are you sure you want to reject this blog?</h1>
                        <p className="text-sm text-gray-500 mt-2">Please provide a reason for rejection.</p>
                        <textarea
                            className="w-full border border-gray-300 rounded-md p-2 mt-2"
                            rows="4"
                            placeholder="Enter reason for rejection"
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                        ></textarea>
                        <div className="flex justify-end mt-4 gap-3">
                            <ActionButton
                                variant={'cancel'}
                                text={"Cancel"}
                                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                                handleSubmit={() => setIsRejectionModelOpen(false)}
                            />
                            <ActionButton
                                variant={'submit'}
                                text={"Reject"}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md mr-2"
                                handleSubmit={() => {
                                    handleReject(currentId);
                                    setIsRejectionModelOpen(false);
                                }}
                            />
                        </div>
                    </div>
                </Modal>
                {/* Approve Model */}
                <Modal isOpen={isModelOpen} setIsOpen={setIsModelOpen} onClose={() => setIsModelOpen(false)}>
                    <div>
                        <h1 className="text-base font-semibold">Are you sure you want to approve this blog?</h1>
                        <h1 className="text-base font-semibold">Note: If you are approving an auto approved blog, it will allocate points to the user for successful blog publishing.</h1>
                        <div className="flex justify-end mt-4 gap-3">
                            <ActionButton
                                variant={'cancel'}
                                text={"Cancel"}
                                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                                handleSubmit={() => setIsModelOpen(false)}
                            />
                            <ActionButton
                                variant={'submit'}
                                text={"Approve"}
                                className="bg-blue-500 text-white px-4 py-2 rounded-md mr-2"
                                handleSubmit={() => {
                                    handleApprove(currentId);
                                    setIsModelOpen(false);
                                    toast.success("Blog Approved");
                                }}
                            />
                        </div>
                    </div>
                </Modal>
                {/* Blog Delete Model */}
                <Modal isOpen={deleteModel} setIsOpen={setDeleteModel} onClose={() => setDeleteModel(false)}>
                    <h1 className="text-base font-semibold">Are you sure you want to delete this blog?</h1>
                    <div className="flex justify-end mt-10 gap-3">
                        <ActionButton
                            variant={'cancel'}
                            text={"Cancel"}
                            handleSubmit={() => {
                                setDeleteModel(false);
                            }}
                        />
                        <ActionButton
                            variant={'submit'}
                            text={"Delete"}
                            handleSubmit={() => {
                                handleDelete(currentId);
                                setDeleteModel(false);
                            }}
                        />
                    </div>
                </Modal>
                <tbody>
                    {
                        data.map((item, index) => (
                            <tr
                                key={item._id}
                                className="border-b border-navBtn hover:bg-gray-50 relative"
                            >
                                <td className="p-3 text-center">{index + 1}</td>
                                <td className="p-3">{item?.title || "-"}</td>
                                <td className={`p-3 ${item?.category?.name ? 'text-left' : 'text-center'}`}>{item?.category?.name ?? "-"}</td>
                                <td className="p-3">{item?.blogType}</td>
                                <td className="p-3 capitalize">{renderBlogCreator(item)}</td>
                                <td className="p-3 capitalize text-center">
                                    {/* {item?.status && renderChipStatus(item?.status)} <p className="mb-1 m-0 p-0 size-0"><br /></p>  */}
                                    {renderChips(item?.active)}
                                </td>
                                <td className="p-3 text-center">{item?.startDate?.toRegularDate() || "-"}</td>
                                <td className="p-3 text-center">{item?.endDate?.toRegularDate() || "-"}</td>
                                <td className="p-3 text-center flex items-center justify-center">
                                    {/* Eye Icon for Attached Product Impact */}
                                    {item?.attachedProduct && (
                                        <button
                                            className="rounded p-1.5 bg-[#29abe233] hover:bg-[#29abe244] mx-1 min-h-7 min-w-7"
                                            onClick={() => onViewImpact && onViewImpact(item)}
                                            title="View Impact Details"
                                        >
                                            <FaEye className="fill-chipBlue" />
                                        </button>
                                    )}
                                    
                                    {/* View Button */}
                                    <button
                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                        onClick={() => navigate('/blogs/edit-blog', { state: { blogId: item?._id } })}
                                    >
                                        <img src={ViewIcon} alt="view" />
                                    </button>
                                    {
                                        item?.createdByUserType === 'user' && (
                                            item?.approvedOn ? (
                                                item?.status === 'active' ? (
                                                    // Reject Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsRejectionModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoClose className="fill-redDark" />
                                                    </button>
                                                ) : (
                                                    // Approve Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoMdCheckmark className="fill-primaryHoverDark" />
                                                    </button>
                                                )
                                            ) : (
                                                (item?.isRejected || item?.status === 'auto approved') ? (
                                                    // Approve Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoMdCheckmark className="fill-primaryHoverDark" />
                                                    </button>
                                                ) : (
                                                    // Reject Button
                                                    <button
                                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                                        onClick={() => {
                                                            setIsRejectionModelOpen(true);
                                                            setCurrentId(item._id);
                                                        }}
                                                    >
                                                        <IoClose className="fill-redDark" />
                                                    </button>
                                                )
                                            )
                                        )
                                    }
                                    {/* Delete Button */}
                                    <button
                                        className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                                        onClick={() => {
                                            setDeleteModel(true);
                                            setCurrentId(item._id);
                                        }}
                                    >
                                        <FaTrash className="fill-chipRed" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
}

export default BlogListTable;